<template>
  <div class="content">
    <div class="content-top">
      <ul>
        <li
          :class="type === 1 ? 'active' : ''"
          @click="
            type = 1
            tab = 0
            queryParams.page = 1
          "
        >
          我的项目
        </li>
        <li
          :class="type === 2 && tplType === 0 ? 'active' : ''"
          @click="
            type = 2
            tplType = 0
            queryParams.page = 1
          "
        >
          个人模板库
        </li>
        <li
          :class="type === 2 && tplType === 1 ? 'active' : ''"
          @click="
            type = 2
            tplType = 1
            queryParams.page = 1
          "
        >
          公共模板库
        </li>
      </ul>
      <ul v-if="type === 1">
        <Button type="primary" @click="visible = true">新建项目</Button>
      </ul>
    </div>
    <div class="content-list" v-show="type === 1">
      <div v-if="list.length === 0" class="noData">
        暂无数据
      </div>
      <div class="section" v-for="item in list" :key="item.id" @click="$router.push({ name: 'combat_camp_detail', query: { id: item.id } })">
        <ul class="title">
          {{
            item.name
          }}
        </ul>
        <ul class="author">
          <span class="name">作者</span>
          <span>{{ item.username }}</span>
        </ul>
        <ul class="date">
          <li>
            <Img src="/icon-date.png" />
            <span>{{ parseTime(item.CreatedAt) }}</span>
          </li>
          <li>
            <Img src="/icon-people.png" />
            <span>成员 {{ item.member || 0 }}</span>
          </li>
        </ul>
        <ul class="des">
          {{
            item.introduce
          }}
        </ul>
        <ul class="progress">
          <span>项目进度</span>
          <Progress :percent="item.progress" strokeColor="#468FEF" />
        </ul>
      </div>
    </div>
    <div class="content-list" v-show="type === 2">
      <div v-if="list.length === 0" class="noData">
        暂无数据
      </div>
      <div class="section" v-for="item in list" :key="item.id" @click="$router.push({ name: 'combat_camp_tpl_detail', query: { id: item.id, tplType } })">
        <ul class="title tpl-title" :class="{ oneBtn: tplType === 1 }">
          <Tooltip :content="item.name" max-width="200">
            <span>{{ item.name }}</span>
          </Tooltip>
          <div class="btn-group">
            <Button
              type="primary"
              @click.stop="
                createObj = item
                createTplVisible = true
              "
              >快速新建</Button
            >
            <Button v-if="tplType === 0" type="error" @click.stop="delTpl(item.id)">删除</Button>
          </div>
        </ul>
        <ul class="author">
          <span class="name">作者</span>
          <span>{{ item.author }}</span>
        </ul>
        <ul class="author">
          <span class="name">项目周期(天)</span>
          <span>{{ item.life }}</span>
        </ul>
        <ul class="date">
          <li>
            <Img src="/icon-date.png" />
            <span>{{ parseTime(item.CreatedAt) }}</span>
          </li>
        </ul>
        <ul class="des">
          {{
            item.introduce
          }}
        </ul>
      </div>
    </div>
    <Page v-if="total > 0" :total="total" @on-change="pageChange" show-total :page-size="12" />
    <CreateFrorm :visible.sync="visible" @ok=";(queryParams.page = 1), getList()" />
    <CreateTplFrorm
      :visible.sync="createTplVisible"
      :createObj="createObj"
      :tplType="tplType"
      @ok="
        queryParams.page = 1
        type = 1
      "
    />
  </div>
</template>
<script>
import { Button, Progress, Page, Tooltip, Modal, Message } from 'view-design'
import Img from '../../components/Img.vue'
import CreateFrorm from './CreateFrorm.vue'
import CreateTplFrorm from './CreateTplFrorm.vue'
export default {
  components: { Button, Progress, Img, CreateFrorm, Page, Tooltip, CreateTplFrorm },
  data() {
    return {
      tab: 0,
      visible: false,
      total: 0,
      loading: true,
      queryParams: {
        size: 12,
        page: 1
      },
      list: [],
      type: 1, // 1-项目， 2-模板库
      createTplVisible: false,
      tplType: 0, // 0-我的模板，1-公共模板
      createObj: {} // 快速新建的模板数据
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const params = {
        uriCode: 'API026',
        all: this.tab,
        ...this.queryParams
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.total = res.total_record
        this.list = res.list
      } finally {
        this.loading = false
      }
    },
    // 获取模版列表
    async getTplList() {
      const params = {
        uriCode: 'ZP_API001',
        type: this.tplType,
        index: this.queryParams.page,
        size: this.queryParams.size
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.total = res.total_record
        this.list = res.list
      } finally {
        this.loading = false
      }
    },
    pageChange(page) {
      this.queryParams.page = page
      this.getList()
    },
    // 删除模版
    delTpl(id) {
      Modal.confirm({
        title: '提示',
        content: '确认删除此模板吗？',
        loading: true,
        onOk: async () => {
          const params = {
            uriCode: 'ZP_API003',
            id
          }
          await this.$fetch(params)
          Modal.remove()
          this.queryParams.page = 1
          this.getTplList()
          Message.success('删除成功！')
        }
      })
    }
  },
  watch: {
    type(val) {
      this.queryParams.page = 1
      if (val === 1) {
        this.getList()
      } else {
        this.getTplList()
      }
    },
    tplType() {
      this.queryParams.page = 1
      this.getTplList()
    }
  }
}
</script>
<style lang="scss" scoped>
.noData {
  color: #999;
  text-align: center;
  line-height: 60px;
  margin: auto;
}
.content {
  height: calc(100vh - 60px);
  padding: 0 !important;
  overflow-y: hidden;
  &-top {
    height: 50px;
    line-height: 50px;
    margin: 10px 0 10px 0;
    background-color: #fff;
    border-radius: 2px;
    padding: 0 31px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    ul {
      display: flex;
      flex-wrap: nowrap;
      li {
        margin-right: 40px;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        color: rgba(28, 42, 52, 0.85);
      }
      li.active {
        font-weight: 600;
        color: #1c2a34;
      }
    }
    .ivu-btn {
      margin-top: 10px;
    }
  }
  &-list {
    background-color: #fff;
    height: calc(100vh - 192px);
    overflow-y: auto;
    padding: 30px 20px;
    border-radius: 2px;
    .section {
      float: left;
      border-radius: 10px;
      border: 1px solid rgba(28, 42, 52, 0.1);
      width: 335px;
      margin: 0 18px 20px 0;
      padding: 20px;
      cursor: pointer;
      transition: all 0.4s ease-in-out;
      .title {
        font-size: 18px;
        font-weight: 600;
        color: #1c2a34;
        line-height: 24px;
        width: 295px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .author {
        display: flex;
        flex-wrap: nowrap;
        margin-top: 12px;
        .name {
          color: rgba(28, 42, 52, 0.45);
          margin-right: 10px;
        }
        font-weight: 400;
        color: #1c2a34;
        line-height: 24px;
      }
      .date {
        :nth-child(1) img {
          height: 16px;
          width: 16px;
          margin-top: -4px;
        }
        :nth-child(2) img {
          height: 18px;
          width: 18px;
          line-height: 22px;
          margin-top: -2px;
        }
        li {
          margin-right: 20px;
          span {
            margin-left: 6px;
            line-height: 22px;
            display: inline-block;
          }
        }
        display: flex;
        flex-wrap: nowrap;
        line-height: 22px;
        font-weight: 400;
        color: rgba(28, 42, 52, 0.45);
        margin-top: 15px;
      }
      .des {
        width: 295px;
        height: 44px;
        line-height: 22px;
        margin-top: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .progress {
        line-height: 20px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-top: 20px;
        span {
          min-width: 48px;
          font-size: 12px;
          color: #1c2a34;
          margin-right: 10px;
        }
        .ivu-progress-inner {
          height: 5px !important;
        }
        .ivu-progress-bg {
          height: 5px !important;
        }
        .ivu-progress-text {
          color: #1c2a34;
          font-size: 12px;
          font-weight: 400;
        }
        .ivu-progress-show-info .ivu-progress-outer {
          margin-right: -35px;
          padding-right: 35px;
        }
        .ivu-icon-ios-checkmark-circle {
          color: #39da8a;
        }
      }
    }
    .section:hover {
      box-shadow: 0px 8px 16px 0px rgba(96, 97, 112, 0.16), 0px 2px 4px 0px rgba(40, 41, 61, 0.04);
    }
    :nth-child(4n) {
      margin-right: 0;
    }
  }
}
.tpl-title {
  display: flex;
  span {
    display: block;
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.oneBtn {
    span {
      width: 225px;
    }
  }
  .btn-group {
    display: flex;
    button {
      &:nth-of-type(2) {
        margin-left: 6px;
      }
    }
    .ivu-btn {
      width: auto !important;
      padding: 0 5px;
    }
  }
}
</style>
